import React from "react";
import { NavLink } from "react-router-dom";

import "./Link.css";

export const Link = ({
  children,
  disabled,
  command = "",
  hidden = false,
  exact = false,
  isActive,
  ...props
}) => {
  if (!props.to) {
    return (
      <div
        className="link"
        title={props.title}
        onClick={props.onClick}
        hidden={hidden}
      >
        {children}
      </div>
    );
  }

  return !disabled ? (
    <NavLink
      hidden={hidden}
      onClick={props.onClick}
      className="link"
      to={props.to}
      title={props.title}
      target={props.target ?? "_self"}
      exact={exact}
      isActive={isActive}
    >
      {children}
    </NavLink>
  ) : (
    <div className="link disabled" title={props.title} hidden={hidden}>
      {children}
    </div>
  );
};
